import React, { FC, useCallback } from 'react';
import key from 'weak-key';
import classNames from 'classnames';
import { ModalName, useToggleModalsContext } from '@/common/contexts/globalModalContext';
import grid from '@/common/css/grid.module.scss';
import styles from './Office.module.scss';

export interface OfficeInfo {
  name: string;
  address: string;
  phones: string[];
  email: string;
}

interface OfficeInfoComponentProps extends OfficeInfo {
  onEmailClick: (officeName: string) => void;
}

const Office: FC<OfficeInfoComponentProps> = ({
  name, address, phones, email, onEmailClick,
}) => {
  const toggleModal = useToggleModalsContext();

  const showContactUsModal = useCallback((): void => {
    onEmailClick(name);
    toggleModal({ [ModalName.contactUs]: true });
  }, [
    name, onEmailClick, toggleModal,
  ]);

  return (
    <div className={classNames(styles.container, grid.colSm6)}>
      <div className={styles.name}>
        {name}
      </div>
      <div className={styles.address}>
        {address}
      </div>
      {phones?.map((phone) => (
        <a key={key({ phone })} className={styles.phone} href={`tel:${phone}`}>{phone}</a>
      ))}
      <div className={styles.email} onClick={showContactUsModal}>
        {email}
      </div>
    </div>
  );
};
Office.displayName = 'Office';

export default Office;
